export default __webpack_public_path__ + "static/media/eth-logo.45466eb1.png";